import styled, { css } from "styled-components";

export const CollorButtonsContainer = styled.div`
  margin: ${({ center }) => (center ? "8px auto" : "8px")};
  margin-bottom: 32px;

  ${({ border }) =>
    border &&
    css`
      /* border: 1px solid #dde5e9;
      border-radius: 8px;
      padding: 4px; */
    `};

  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CollorButton = styled.div`
  font-family: "Inter", sans-serif;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 2px solid #dde5e9;
  border-radius: 8px;
  padding: 4px 8px;
  transition: all 0.3s ease-in-out;

  &:hover {
    border-color: rgba(17, 167, 217, 0.8);
    box-shadow: 0px 0px 20px 1px rgba(17, 167, 217, 0.45);
  }

  ${({ active }) =>
    active &&
    css`
      &,
      &:hover {
        cursor: default;
        box-shadow: 0px 0px 10px 2px rgba(17, 167, 217, 0.38);
        border-color: #11a7d9;
      }
    `};
`;
